import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { useTheme, withStyles } from '@material-ui/core/styles';

import { fieldLabel } from 'core/helpers/sentence-case';

import { ElemType, MapClassesToElem } from '../../helpers/styles-helpers';
import styles from './text-field.styles';
import Mask from './mask';

const StyledTextField = ({
  classes,
  inputRef,
  readOnly,
  inputProps = {},
  mode,
  labelProps,
  InputProps,
  label,
  ...props
}) => {
  const theme = useTheme();
  const classPrefix = mode || 'default';
  return (
    <TextField
      {...props}
      label={fieldLabel(theme, label)}
      InputProps={{
        inputRef,
        readOnly,
        autoComplete: 'off',
        disableUnderline: true,
        classes: MapClassesToElem(`${classPrefix}-${ElemType.TextField}`, classes),
        inputComponent: InputProps.inputProps && InputProps.inputProps.mask && Mask,
        ...InputProps
      }}
      InputLabelProps={{
        classes: MapClassesToElem(`${classPrefix}-${ElemType.Label}`, classes),
        ...labelProps
      }}
      FormHelperTextProps={{
        classes: MapClassesToElem(`${classPrefix}-${ElemType.FormHelper}`, classes)
      }}
      inputProps={{ ...inputProps, ...InputProps.inputProps }}
    />
  );
};

StyledTextField.propTypes = {
  classes: PropTypes.object,
  inputRef: PropTypes.func,
  readOnly: PropTypes.bool,
  mode: PropTypes.oneOf([null, 'light', 'dark', 'red']),
  labelProps: PropTypes.object,
  inputProps: PropTypes.object,
  InputProps: PropTypes.object
};

StyledTextField.defaultProps = {
  classes: null,
  inputRef: null,
  readOnly: null,
  labelProps: null,
  mode: null,
  inputProps: null,
  InputProps: {}
};

export default withStyles(styles)(StyledTextField);
